import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../../../commons/services/common.service';
import { ConstanteEcorec } from '../../../../../application/constante.ecorec';

@Component({
  selector: 'app-tarif-transporteur',
  templateUrl: './tarif-transporteur.component.html',
  styleUrls: ['./tarif-transporteur.component.css']
})
export class TarifTransporteurComponent implements OnInit {

  public transporteur: any = {}; // l'objet principal
  public rowSelect: any = {};
  public loadingIndicator: Boolean = false;
  public dataArticle = [];
  public dataClient = [];
  public dataChantier = [];
  public listeSite = [];
  public listPrix = [];
  public listQualitePrix = [];
  public classPresta: String = 'detailfact ';
  public dataExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  isEmpty: Boolean = false;
  @Output() public callback: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set setTransporteur(val: any) {
    this.transporteur = val;
    if (this.transporteur && this.transporteur['listPrix']) {
      this.transporteur.listPrix.forEach(elt => {
        if (elt.qualitePrix) {
          elt.qualitePrix.libelleObjetEntite = elt.qualitePrix.libelle;
        }

        if (elt.client) {
          elt.client.libelleObjetEntite = elt.client.codeClient + '/' + elt.client.nomClient;
        }

        if (elt.site) {
          elt.site.libelleObjetEntite = elt.site.nom;
        }

        if (elt.chantier) {
          elt.chantier.libelleObjetEntite = elt.chantier.numChantier;
        }

        this.listPrix.push(elt);
      });
    }
  }

  constructor(public common: CommonService) {

  }

  ngOnInit() {
    this.loadListQualitePrix();
    this.searchSite();
  }

  loadListQualitePrix() {
    const param = {
      'servlet': 'DBGetListQualitePrix',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': []
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.listQualitePrix = [];
        for (let i = 0; i < datas.data[0].length; i++) {
          this.listQualitePrix.push({
            id: datas.data[0][i],
            libelle: datas.data[1][i],
            libelleObjetEntite: datas.data[1][i]
          });
        }
      }
    });
  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = 4;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.dataExutoire = l;
      }
    });
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };

    this.common.searchEcoloc({ param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  searchChantier(row, event) {
    this.dataChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    if (row['client'] && row['client'].id && row['client'].id > 0) {
      const param = {
        'servlet': 'DBGetChantierClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {

          'SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': row['client'].id
          },
          'CRITERE': event || ''
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          this.dataChantier = [...this.dataChantier, ...datas.data];
        }
      });
    }
  }

  searchSite() {
    this.listeSite = this.common.local.getObject('listeSite') || [];
    this.listeSite.forEach(elt => elt.libelleObjetEntite = elt.nom);
  }

  showInput(index?) {
    const ctrl = this;
  }

  deleteLigne(row) {
    const temp = this.listPrix.filter(elt => elt !== row);
    this.listPrix = temp;
  }

  addLigne() {
    this.listPrix.push({ artColonne1: { id: 0, code: '' }, unitaire: false, pourcentageNomenclature: 0, dit: true });
    this.listPrix = [...this.listPrix];
    this.showInput();
  }

  annuler() {
    this.callback.emit();
  }

  save() {
    const ctrl = this;
    this.transporteur.listPrix = [];
    this.listPrix.forEach(elt => {
      if (!elt['qualitePrix'] || (elt['qualitePrix'] && !elt['qualitePrix'].id)) {
        elt['qualitePrix'] = { id: 0 };
      }

      if (!elt['article'] || (elt['article'] && !elt['article'].id)) {
        elt['article'] = { id: 0 };
      }

      if (!elt['exutoire'] || (elt['exutoire'] && !elt['exutoire'].id)) {
        elt['exutoire'] = { id: 0 };
      }

      if (!elt['tarif']) {
        elt['tarif'] = 0;
      }

      if (!elt['client'] || (elt['client'] && !elt['client'].id)) {
        elt['client'] = { id: 0 };
      }

      if (!elt['chantier'] || (elt['chantier'] && !elt['chantier'].id)) {
        elt['chantier'] = { id: 0 };
      }

      if (!elt['site'] || (elt['site'] && !elt['site'].id)) {
        elt['site'] = { id: 0 };
      }

      this.transporteur.listPrix.push(elt);
    });
    this.callback.emit();
  }

  updateArtColonne1(event) {
  }
}
